var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1704 20.5136L15.4152 20.3116C16.1185 20.1984 16.7733 19.867 17.2744 19.3577L18.4304 18.2018C18.9558 17.6763 18.9558 16.8276 18.4304 16.3021L15.7709 13.6426C15.2455 13.1172 14.3967 13.1172 13.8713 13.6426L11.9393 15.5746L5.56948 9.20479L7.50145 7.27282C8.02688 6.7474 8.02688 5.89862 7.50145 5.37319L4.84197 2.71371C4.31654 2.18828 3.46777 2.18828 2.94234 2.71371L1.78639 3.86966C1.27713 4.37892 0.945705 5.0256 0.832535 5.72887L0.630447 6.97373C0.452609 8.04884 0.808285 9.1482 1.5843 9.91614L11.2118 19.5436C11.9797 20.3116 13.0791 20.6672 14.1542 20.4975L14.1704 20.5136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1067 1C13.362 1.21017 15.5526 2.17211 17.2744 3.8939C18.9962 5.6157 19.9582 7.80633 20.1683 10.0616",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9107 10.0535C16.7167 8.63085 16.0781 7.26473 14.9868 6.17345C13.8955 5.08218 12.5294 4.44358 11.1067 4.24957",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelWh);
export default __webpack_public_path__ + "static/media/icon_tel_wh.9f9742e8b7242f3ccf607862f7dc5f61.svg";
export { ForwardRef as ReactComponent };